import React from 'react';
import PropTypes from 'prop-types';

const EmailComposition = ({ answerText, body }) => (
  <div className="mt-24" data-testid="EmailComposition">
    <span className="fw-b fz-16">
      {t('questions.question.email_practice.subject')}
    </span>
    <div className="Card bg-white p-32 mt-8 mb-24">
      <span className="fz-16 fs-i border-left-solid border-left-1 border-gray pl-16">
        {answerText}
      </span>
    </div>
    <span className="fw-b mt-16 fz-16">
      {t('questions.question.email_composition.body')}
    </span>
    <div className="Card bg-white p-32 mt-8">
      <span className="fz-16 fs-i border-left-solid border-left-1 border-gray pl-16">
        {body}
      </span>
    </div>
  </div>
);

EmailComposition.propTypes = {
  answerText: PropTypes.string,
  body: PropTypes.string,
};

export default EmailComposition;
